/* Dad Bod Destroyer page (sections/dbd-hero.liquid): countdown, gallery, stack options, flavours, subscribe toggle and
   add to cart. Subscribe on/off puts .dbd-once on <html>, which switches every .dbd-if-sub / .dbd-if-once price on the
   page (all prices are rendered by Liquid, so the currency app converts them). */
(function () {
  function startTimer(el) {
    var minutes = parseInt(el.getAttribute('data-minutes'), 10) || 10;
    var key = 'dbd-timer-end';
    var end = 0;
    try { end = parseInt(sessionStorage.getItem(key), 10) || 0; } catch (e) { /* storage blocked */ }
    function reset() {
      end = Date.now() + minutes * 60000;
      try { sessionStorage.setItem(key, String(end)); } catch (e) { /* storage blocked */ }
    }
    if (end <= Date.now()) reset();
    function tick() {
      var left = Math.max(0, Math.round((end - Date.now()) / 1000));
      if (!left) { reset(); left = minutes * 60; }
      var m = Math.floor(left / 60), s = left % 60;
      el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }
    tick();
    setInterval(tick, 1000);
  }

  function init(root) {
    if (root.getAttribute('data-dbd-ready')) return;
    root.setAttribute('data-dbd-ready', '1');

    root.querySelectorAll('[data-dbd-timer]').forEach(startTimer);

    /* Gallery: a thumbnail shows its image in the main frame; pressing it again goes back to the main image */
    var thumbs = root.querySelectorAll('[data-dbd-thumb]');
    var slides = root.querySelectorAll('[data-dbd-slide]');
    function show(n) {
      slides.forEach(function (s) { s.hidden = s.getAttribute('data-dbd-slide') !== String(n); });
      thumbs.forEach(function (t) { t.setAttribute('aria-pressed', String(t.getAttribute('data-dbd-thumb') === String(n))); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        show(t.getAttribute('aria-pressed') === 'true' ? 0 : t.getAttribute('data-dbd-thumb'));
      });
    });

    var cfgEl = root.querySelector('[data-dbd-config]');
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var tiers = root.querySelectorAll('[data-dbd-tier]');
    var flavours = root.querySelectorAll('[data-dbd-flavour]');
    var sub = root.querySelector('[data-dbd-sub]');
    var btn = root.querySelector('[data-dbd-atc]');
    var errorEl = root.querySelector('[data-dbd-error]');

    function months() {
      var on = root.querySelector('[data-dbd-tier][aria-pressed="true"]');
      return on ? parseInt(on.getAttribute('data-dbd-tier'), 10) : 1;
    }
    function showError(msg) { if (errorEl) errorEl.textContent = msg || ''; }

    function selectTier(n) {
      tiers.forEach(function (t) { t.setAttribute('aria-pressed', String(t.getAttribute('data-dbd-tier') === String(n))); });
      flavours.forEach(function (sel) {
        var label = sel.closest('label');
        if (label) label.hidden = parseInt(sel.getAttribute('data-dbd-flavour'), 10) > n;
      });
      root.querySelectorAll('[data-dbd-month-label]').forEach(function (l) { l.hidden = n < 2; });
      showError('');
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function () { selectTier(parseInt(t.getAttribute('data-dbd-tier'), 10)); });
    });

    if (sub) {
      sub.addEventListener('change', function () { document.documentElement.classList.toggle('dbd-once', !sub.checked); });
    }

    function lines() {
      var n = months();
      var subscribed = !!(sub && sub.checked);
      var items = [];
      for (var i = 0; i < cfg.products.length; i++) {
        var p = cfg.products[i];
        if (!p.found || !p.variant || !p.available) return null;
        var counts = {};
        var order = [];
        if (p.flavours && flavours.length) {
          for (var m = 0; m < n; m++) {
            var id = flavours[m] ? flavours[m].value : String(p.variant);
            if (!counts[id]) { counts[id] = 0; order.push(id); }
            counts[id] += 1;
          }
        } else {
          counts[p.variant] = n;
          order.push(String(p.variant));
        }
        order.forEach(function (id) {
          var item = { id: parseInt(id, 10), quantity: counts[id], properties: { _jx_stack: String(n) } };
          if (subscribed && p.plan) item.selling_plan = p.plan;
          items.push(item);
        });
      }
      return items;
    }

    if (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-disabled') === 'true') return;
        var items = lines();
        if (!items || !items.length) { showError(cfg.errors.unavailable); return; }
        showError('');
        btn.setAttribute('aria-disabled', 'true');

        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var body = { items: items };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map(function (x) { return x.id; });
          body.sections_url = window.location.pathname;
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }
        var canPublish = typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
        var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
        fetch(url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) {
              showError(res.description || res.message || cfg.errors.generic);
              if (canPublish) publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: items[0].id, errors: res.errors || res.description, message: res.message });
              return;
            }
            if (!cart || typeof cart.renderContents !== 'function') {
              window.location = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
              return;
            }
            /* jx-gifts.js listens for this and adds the free gifts the subscription bottles earn */
            if (canPublish) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: items[0].id, cartData: res });
            cart.renderContents(res);
            if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          })
          .catch(function (e) { console.error(e); showError(cfg.errors.generic); })
          .finally(function () { btn.removeAttribute('aria-disabled'); });
      });
    }
  }

  function boot() { document.querySelectorAll('[data-dbd-hero]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
